import { render } from "./CardServDashMain.vue?vue&type=template&id=32d08168&scoped=true"
import script from "./CardServDashMain.vue?vue&type=script&lang=js"
export * from "./CardServDashMain.vue?vue&type=script&lang=js"

import "./CardServDashMain.vue?vue&type=style&index=0&id=32d08168&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d08168"]])

export default __exports__